import "./Sidebar.css";
import React, { useState, useEffect } from "react";
import { slide as Menu } from "react-burger-menu";
import icon from "../../../assets/svg/Sidebar-icon.svg";
import sb_closed from "../../../assets/svg/Vector.svg";
import logo from "../../../assets/svg/Logo.svg";
import Home from "../../../assets/svg/Home-icon.svg";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [rol, setrol] = useState();

  useEffect(() => {
    let rol_ls = new Buffer(localStorage.getItem("rol"), "base64");
    let rol_str = rol_ls.toString("ascii");
    setrol(rol_str);
  }, []);

  return (
    <div>
      <Menu
        customBurgerIcon={<img src={sb_closed} alt="ícono sidebar" />}
        customCrossIcon={<img src={icon} alt="ícono cerrar" />}
      >
        <div>
          <Link id="logo" className="sb-item menu-item" to="/dashboard">
            <img src={logo} alt="logo airtek" />
          </Link>

          <Link id="home" className="sb-item menu-item" to="/dashboard">
            <img src={Home} alt="ícono inicio" className="me-3" />
            Inicio
          </Link>

          <Link id="mdt" className="sb-item menu-item" to="/reasignar">
            <i className="fa-solid fa-hard-drive me-3"></i>
            Reasignar MDT
          </Link>

          <Link id="aliados" className="sb-item menu-item" to="/aliados">
            <i className="fas fa-building me-3"></i>
            Aliados Comerciales
          </Link>

          {rol === `${process.env.REACT_APP_ROL1}` && (
            <Link id="usuarios" className="sb-item menu-item" to="/usuarios">
              <i className="fa-solid fa-users me-3"></i>
              Usuarios
            </Link>
          )}

          <div
            className="accordion accordion-flush mt-4 dropdown-sbar"
            id="accordionFlushExample3"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button dropdown-sb collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  <i className="fa-solid fa-file me-3"></i>
                  Reportes
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample3"
              >
                <div className="accordion-body">
                  <Link
                    id="cambiar-pwd"
                    className="sb-item menu-item"
                    to="/clientes-asignados"
                  >
                    Clientes Asignados
                  </Link>

                  <Link
                    id="instalaciones"
                    className="sb-item menu-item"
                    to="/instalaciones"
                  >
                    Instalaciones
                  </Link>

                  <Link
                    id="instalaciones"
                    className="sb-item menu-item"
                    to="/cambio-de-plan"
                  >
                    Cambio de Plan
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div
            className="accordion accordion-flush mt-4 dropdown-sbar"
            id="accordionFlushExample2"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button dropdown-sb collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  <i className="fa-solid fa-gear me-3"></i>
                  Configuración
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample2"
              >
                <div className="accordion-body">
                  <Link
                    id="cambiar-pwd"
                    className="sb-item menu-item"
                    to="/cambiar-pwd"
                  >
                    Cambiar Contraseña
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <footer className="sb-footer">
            <div className="d-flex">
              <p className="mb-0 sb-version">
                v.{process.env.REACT_APP_VERSION}
              </p>
            </div>
          </footer>
        </div>
      </Menu>
    </div>
  );
};

export default Sidebar;
